module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ge-list",
    class: {
      loading: _vm.list.loading
    }
  }, [_c('div', {
    staticClass: "employee-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [(_vm.filter.subjectSelect) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Vælg fag")]), _vm._v(" "), _vm._l((_vm.filter.subjectSelect), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.filter.titleSelect) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Vælg jobtitel")]), _vm._v(" "), _vm._l((_vm.filter.titleSelect), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    class: ['search-message', {
      'show': _vm.showMessage
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.messageStatus)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "results"
  }, _vm._l((_vm.list.results.items), function(item) {
    return _c('div', {
      key: item.id,
      class: ['employee', {
        'no-image': !item.image
      }]
    }, [(item.image) ? _c('sky-crop', {
      attrs: {
        "src": item.image.skyCropUrl,
        "alt": item.image.alttext,
        "mode": "cover",
        "svg-filter": true
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.subjects.length > 0) ? _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.subjectString(item.subjects))
      }
    }) : _vm._e(), _vm._v(" "), (item.phone) ? _c('span', {
      domProps: {
        "textContent": _vm._s(item.phone)
      }
    }) : _vm._e(), _vm._v(" "), (item.email) ? _c('a', {
      attrs: {
        "href": ("mailto:" + (item.email))
      },
      domProps: {
        "textContent": _vm._s(item.email)
      }
    }) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-2f2de404"}!./scripts/ge-list/ge-list.html
// module id = 347
// module chunks = 1